import {
  AdditionalNeeds,
  ChangedMind,
  CurrentSupplierWinback,
  FeesFromSupplier,
  FoundBetterDeal,
  IncorrectDetails,
  NeverWantedToSwitch,
  NotEnoughInformation,
  PoorCustomerService,
  SalesQuoteWrong,
  SmartMeterIssues,
  TechnicalIssues,
  TooManyEmails,
} from "@/views/myaccount/home/components/switch-cancellation-modal/switch-cancellation-articles"

export const suppliers = [
  "British Gas",
  "EON",
  "Octopus",
  "EDF",
  "Scottish Power",
  "OVO",
  "SSE",
  "Other",
]

export const cancellationReasons = [
  {
    label: "Pricing, costs and money",
    value: "costCancellation",
    reasons: [
      {
        label: "I found a cheaper tariff elsewhere",
        value: "Found a better deal",
        suppliers: suppliers,
        article: FoundBetterDeal,
      },
      {
        label: "My current supplier will charge exit fees if I switch now",
        value: "Fees from previous supplier",
        article: FeesFromSupplier,
      },
      {
        label: "My current supplier offered me a better deal",
        value: "Current supplier winback",
        article: CurrentSupplierWinback,
      },
      {
        label: "Other",
        value: "Other",
      },
    ],
  },
  {
    label: "I'm not happy with the service so far",
    value: "serviceCancellation",
    reasons: [
      {
        label: "My details are incorrect",
        value: "Incorrect details",

        article: IncorrectDetails,
      },
      {
        label: "I received too many emails",
        value: "Too many emails",

        article: TooManyEmails,
      },
      {
        label: "I've changed my mind",
        value: "Changed mind",

        article: ChangedMind,
      },
      {
        label: "The sales quote was inaccurate",
        value: "Sales quote was wrong",

        article: SalesQuoteWrong,
      },
      {
        label: "I didn't want to switch to So Energy, this was a mistake",
        value: "Never wanted to switch",

        article: NeverWantedToSwitch,
      },
      {
        label: "I experienced poor customer service",
        value: "Experienced poor customer service",

        article: PoorCustomerService,
      },
      {
        label: "I don't have enough information about the switch",
        value: "Didn't have enough information",

        article: NotEnoughInformation,
      },
    ],
  },
  {
    label: "I've experienced or predict issues",
    value: "issuesCancellation",
    reasons: [
      {
        label: "I have additional needs that aren't catered for",
        value: "Additional needs",
        article: AdditionalNeeds,
      },
      {
        label:
          "I will lose my smart meter functionality or have unresolved smart meter issues",
        value: "Smart meter issues",
        article: SmartMeterIssues,
      },
      {
        label: "I experienced technical issues when switching to So Energy",
        value: "Technical issues",
        article: TechnicalIssues,
      },
    ],
  },
]
